export const SELECT_QUOTE = 'search-select-quote';
const selectQuote = ({ quote }) => ({ type: SELECT_QUOTE, payload: { quote } });
export default selectQuote;
